import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-offwhite text-warmgray">
        <span className="eyebrow">Carregando…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/backoffice/login" replace />;
  return children;
}
